// Thirdparty
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/effect-fade'
import 'swiper/css/thumbs'

// Theme
import '@styles/index.css'

import mailingList from '@scripts/components/mailing-list'

import components from '@scripts/components'
import mobileBar from '@scripts/components/mobile-bar'
import pageOverlay from '@scripts/components/page-overlay'
import scrollTo from '@scripts/components/scroll-to'
import siteAnnouncementBar from '@scripts/components/site-announcement-bar'
import scrollReveal from '@scripts/components/scroll-reveal'
import siteHeader from '@scripts/components/site-header'
import siteWidget from '@scripts/components/site-widget'
import slideToggle from '@scripts/components/slide-toggle'

mailingList.init()

components.init()
mobileBar.init()
pageOverlay.init()
if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  scrollReveal.init()
}
scrollTo.init()
siteAnnouncementBar.init()
siteHeader.init()
siteWidget.init()
slideToggle.init()

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    document.documentElement.classList.remove('_preload')
  }, 250)
})
